/**
 * Whether the evolution response carries the position analyzer's shape.
 *
 * Every other analyzer sends a plain number per series; position sends
 * `{price, pricePosition, isMainData}`, which amcharts cannot plot as-is.
 */
export const isRankEvolutionData = (chartData = []) => chartData.some(row =>
	Object.entries(row || {}).some(([key, value]) =>
		key !== 'date' && value && typeof value === 'object' && 'pricePosition' in value))
